<div class="filter-container relative">
  <button (click)="toggleFilterPanel(); $event.stopPropagation();" class="filter-button flex items-center text-gray-600 hover:bg-gray-100 rounded-md p-2">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd" />
    </svg>
    <span class="ml-1 text-sm">Filter</span>
  </button>

  <!-- Filter Panel -->
  @if (showFilter()) {
    <div (click)="$event.stopPropagation()" class="filter-panel absolute right-0 top-12 bg-white rounded-lg shadow-lg p-5 w-80 border border-gray-200 z-50">
      <div class="flex justify-between items-center mb-1">
        <h3 class="text-gray-800 font-medium text-lg">Select Filters</h3>
        <div class="text-blue-600 text-sm flex items-center cursor-pointer">
          {{ selectedFiltersCount }} selected
        </div>
      </div>
      <p class="text-gray-500 text-sm mb-4">Filter assets by status and risk</p>

      <!-- Battery Status -->
      <div class="mb-4">
        <h4 class="text-sm font-medium text-gray-700 mb-2">Battery Status</h4>
        <div class="flex flex-wrap gap-2">
          <button
            class="px-4 py-2 rounded-full border text-sm flex items-center"
            [class.border-blue-500]="filters().online"
            [class.border-gray-200]="!filters().online"
            [class.bg-blue-50]="filters().online"
            [class.bg-gray-50]="!filters().online"
            [class.text-blue-700]="filters().online"
            [class.text-gray-700]="!filters().online"
            (click)="toggleFilter('online')">
            @if (filters().online) {
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            }
            Online
          </button>
          <button
            class="px-4 py-2 rounded-full border text-sm flex items-center"
            [class.border-blue-500]="filters().offline"
            [class.border-gray-200]="!filters().offline"
            [class.bg-blue-50]="filters().offline"
            [class.bg-gray-50]="!filters().offline"
            [class.text-blue-700]="filters().offline"
            [class.text-gray-700]="!filters().offline"
            (click)="toggleFilter('offline')">
            @if (filters().offline) {
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            }
            Offline
          </button>
        </div>
      </div>

      <!-- Asset -->
      <div class="mb-4">
        <h4 class="text-sm font-medium text-gray-700 mb-2">Asset</h4>
        <div class="flex flex-wrap gap-2">
          <button
            class="px-4 py-2 rounded-full border text-sm flex items-center"
            [class.border-blue-500]="filters().overspeeding"
            [class.border-gray-200]="!filters().overspeeding"
            [class.bg-blue-50]="filters().overspeeding"
            [class.bg-gray-50]="!filters().overspeeding"
            [class.text-blue-700]="filters().overspeeding"
            [class.text-gray-700]="!filters().overspeeding"
            (click)="toggleFilter('overspeeding')">
            @if (filters().overspeeding) {
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            }
            Over-speeding
          </button>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex justify-end space-x-2 mt-6">
        <button
          class="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
          (click)="resetFilters()">
          Reset
        </button>
        <button
          (click)="applyFilters()"
          class="px-4 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700">
          Apply
        </button>
      </div>
    </div>
  }
</div>
